// Define theme object for consistent styling across components
export const theme = {
  colors: {
    primary: '#8B4513', // Warm brown
    secondary: '#722F37', // Deep burgundy
    accent: '#2F4F4F', // Dark slate
    dark: '#3D3635', // Dark brown
    light: '#F5F1ED', // Warm off-white
    burgundy: '#5B0E2D', // Rich burgundy
    slate: '#4E5754', // Medium slate
    caramel: '#C68E17', // Warm caramel accent
    taupe: '#8E7F7D', // Neutral taupe
  },
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Cormorant Garamond', serif",
    accent: "'Montserrat', sans-serif",
  },
  shadows: {
    small: '0 2px 10px rgba(61, 54, 53, 0.15)',
    medium: '0 4px 20px rgba(61, 54, 53, 0.2)',
    large: '0 8px 30px rgba(61, 54, 53, 0.25)',
  },
  borderRadius: {
    small: '2px',
    medium: '4px',
    large: '8px',
  }
}; 